export default __webpack_public_path__ + "static/media/prof.c56c5560.gif";